import { useCreate } from "@refinedev/core";
import { useCallback, useState } from "react";
import { InitSubscriptionParams } from "types";

export default function useGetSubscriptions({
  organizationId,
}: {
  organizationId: string;
}) {
  const { mutateAsync: initSubscription, isLoading } =
    useCreate<InitSubscriptionParams>();
  const [subscriptionParams, setSubscriptionParams] =
    useState<InitSubscriptionParams>();

  const init = useCallback(async () => {
    if (!organizationId) return;

    const res = await initSubscription({
      resource: `api/organizations/${organizationId}/payments`,
      successNotification: false,
      values: { source: "stripe" },
    });
    const params = res?.data;
    // Cannot send both of those to Stripe
    if (params?.customer_session_client_secret === null) {
      delete params?.customer_session_client_secret;
    } else {
      delete params?.customer_email;
    }
    setSubscriptionParams(params);
  }, [organizationId, initSubscription]);

  return { params: subscriptionParams, isLoading, init };
}
